import { render } from "./ToSPrivacy.vue?vue&type=template&id=6f154abc&scoped=true"
import script from "./ToSPrivacy.vue?vue&type=script&lang=js"
export * from "./ToSPrivacy.vue?vue&type=script&lang=js"

import "./ToSPrivacy.vue?vue&type=style&index=0&id=6f154abc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f154abc"]])

export default __exports__